import React from "react";

import HeroSection from "../components/marketing/HeroSection";
import DifferenceSection from "../components/marketing/DifferenceSection";
import ValuePropositionsSection from "../components/marketing/ValuePropositionsSection";
import RelationshipDynamicsSection from "../components/marketing/RelationshipDynamicsSection";
import CTASection from "../components/marketing/CTASection";

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <HeroSection />
      <DifferenceSection />
      <ValuePropositionsSection />
      <RelationshipDynamicsSection />
      <CTASection />
    </div>
  );
} 